import { ReferenceImage } from "domains/inference/interfaces/InferenceGenerator";

export const PROMPT_EDIT_MODELS = ["gpt-image-1", "gemini-2.0-flash"] as const;
export type PromptEditModel = (typeof PROMPT_EDIT_MODELS)[number];
export const PROMPT_EDIT_MODEL_LABELS: {
  [key in PromptEditModel]: string;
} = {
  "gemini-2.0-flash": "Gemini 2.0 Flash",
  "gpt-image-1": "GPT Image 1",
};

export const PROMPT_EDIT_MODEL_OPTIONS = PROMPT_EDIT_MODELS.map((model) => ({
  label: PROMPT_EDIT_MODEL_LABELS[model],
  value: model,
}));

// ------------------------------------

export const PROMPT_EDIT_ASPECT_RATIOS = ["auto", "1:1", "2:3", "3:2"] as const;
export type PromptEditAspectRatio = (typeof PROMPT_EDIT_ASPECT_RATIOS)[number];
export const PROMPT_EDIT_ASPECT_RATIO_LABELS: {
  [key in PromptEditAspectRatio]: string;
} = {
  auto: "Auto",
  "1:1": "1:1",
  "2:3": "2:3",
  "3:2": "3:2",
};

export const PROMPT_EDIT_ASPECT_RATIO_OPTIONS = PROMPT_EDIT_ASPECT_RATIOS.map(
  (aspectRatio) => ({
    label: PROMPT_EDIT_ASPECT_RATIO_LABELS[aspectRatio],
    value: aspectRatio,
  })
);

// ------------------------------------

export const PROMPT_EDIT_QUALITIES = ["high", "medium", "low"] as const;
export type PromptEditQuality = (typeof PROMPT_EDIT_QUALITIES)[number];
export const PROMPT_EDIT_QUALITY_LABELS: {
  [key in PromptEditQuality]: string;
} = {
  high: "High",
  medium: "Medium",
  low: "Low",
};

export const PROMPT_EDIT_QUALITY_OPTIONS = PROMPT_EDIT_QUALITIES.map(
  (quality) => ({
    label: PROMPT_EDIT_QUALITY_LABELS[quality],
    value: quality,
  })
);

// ------------------------------------

export type PromptEditForm = {
  count: number;
  prompt: string;
  reference:
    | {
        src: string;
        assetId?: string;
        dimensions?: { width: number; height: number };
      }
    | undefined;
  model: PromptEditModel;
  refImages: ReferenceImage[];
  aspectRatio: PromptEditAspectRatio;
  quality: PromptEditQuality;
};
